/* global REACT_APP_PUBLIC_MONITORING_SOCKET_URL */
import { useEffect } from 'react';
import io from 'socket.io-client';
import PropTypes from 'prop-types';

export const LiveTraffic = ({ channel }) => {
  useEffect(() => {
    if (!channel) return;

    const URL = REACT_APP_PUBLIC_MONITORING_SOCKET_URL || '';

    if (!URL) {
      return;
    }

    const socket = io(URL);

    socket.on('connect', () => {
      socket.emit('subscribe', channel);
    });

    return () => {
      if (socket.connected) {
        socket.emit('unsubscribe', channel);
      }
      socket.disconnect();
    };
  }, [channel]);

  return null;
};

LiveTraffic.propTypes = {
  channel: PropTypes.string,
};
